"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _consts = require("../primitives/IllustrationPrimitive/consts");

var _IllustrationPrimitive = _interopRequireDefault(require("../primitives/IllustrationPrimitive"));

var Illustration = function Illustration(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _consts.SIZE_OPTIONS.MEDIUM : _ref$size,
      props = (0, _objectWithoutProperties2.default)(_ref, ["size"]);
  return /*#__PURE__*/React.createElement(_IllustrationPrimitive.default, (0, _extends2.default)({}, props, {
    size: size
  }));
};

var _default = Illustration;
exports.default = _default;